ROW_IMPRESSION_GA4_EVENT